<template>
  <div class="bg-gray-100">
    <div class="container mx-auto p-6 pt-12 text-center">
      <h1 class="text-2xl font-bold mb-4">Associazione Tau APS</h1>
      <p class="text-lg">Privacy Policy</p>
    </div>
    <!-- Main Content -->
    <main class="container mx-auto p-6 pb-12">
      <section class="bg-white shadow-md rounded-lg p-6 mb-8">
        <p class="mb-4 text-sm">
          La presente Privacy Policy descrive come Associazione Tau APS (di seguito "noi", "nostro/a", "associazione")
          raccoglie, utilizza, protegge e condivide i dati personali degli utenti (di seguito "utente" o "tu") che
          visitano il nostro sito web <a href="https://www.associazionetau.it"
            class="text-blue-500">www.associazionetau.it</a>. Questa politica è importante per proteggere la tua privacy
          e i tuoi dati personali.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-3">1. Titolare del trattamento dei dati</h2>
        <p class="mb-4 text-sm">
          Il titolare del trattamento dei dati personali è <strong>Associazione Tau APS</strong>, con sede legale in
          Via Cimabue 19, 09045 Quartu Sant'Elena, C.F. 92236610926.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-3">2. Dati personali raccolti</h2>
        <p class="mb-4 text-sm">
          Raccogliamo i seguenti dati personali:
        </p>
        <ul class="list-disc pl-6 mb-4 text-sm">
          <li><strong>Dati forniti tramite il form di contatto</strong>: Quando invii una richiesta tramite il nostro
            form di contatto, raccogliamo informazioni come il tuo nome, indirizzo email, numero di telefono e qualsiasi
            altro dato che decidi di inserire nel messaggio.</li>
          <li><strong>Dati di navigazione</strong>: Utilizziamo strumenti di analisi web come Google Analytics e
            Microsoft Clarity per raccogliere informazioni anonime sulla tua attività di navigazione sul nostro sito,
            inclusi dati come l'indirizzo IP, il tipo di dispositivo, il sistema operativo, la durata della visita e le
            pagine visitate.</li>
        </ul>

        <h2 class="text-xl font-semibold mt-6 mb-3">3. Finalità del trattamento dei dati</h2>
        <p class="mb-4 text-sm">
          I dati personali raccolti sono trattati per le seguenti finalità:
        </p>
        <ul class="list-disc pl-6 mb-4 text-sm">
          <li><strong>Gestione richieste tramite il form di contatto</strong>: I dati forniti tramite il form di
            contatto sono utilizzati per rispondere alle tue richieste e per comunicare con te in merito a informazioni
            relative alla nostra associazione.</li>
          <li><strong>Analisi delle prestazioni del sito</strong>: Utilizziamo Google Analytics per analizzare l'uso del
            sito, migliorare i contenuti e ottimizzare la navigazione. I dati raccolti tramite Google Analytics sono
            anonimi e non ti identificano personalmente.</li>
          <li><strong>Miglioramento dell'esperienza utente</strong>: Microsoft Clarity ci aiuta a comprendere come gli
            utenti interagiscono con il sito, al fine di migliorarne l'usabilità e l'esperienza complessiva.</li>
        </ul>

        <h2 class="text-xl font-semibold mt-6 mb-3">4. Base giuridica del trattamento</h2>
        <p class="mb-4 text-sm">
          Il trattamento dei tuoi dati personali si basa su:
        </p>
        <ul class="list-disc pl-6 mb-4 text-sm">
          <li><strong>Il consenso</strong> che ci fornisci quando compili il form di contatto o quando accetti i cookie
            di Analytics e Clarity.</li>
          <li><strong>Il nostro legittimo interesse</strong> nel migliorare il sito e fornire un servizio adeguato agli
            utenti.</li>
        </ul>

        <h2 class="text-xl font-semibold mt-6 mb-3">5. Modalità di trattamento dei dati</h2>
        <p class="mb-4 text-sm">
          I dati personali sono trattati in modo lecito e trasparente, adottando adeguate misure di sicurezza per
          proteggerli da accessi non autorizzati, alterazioni, divulgazione o distruzione.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-3">6. Conservazione dei dati</h2>
        <p class="mb-4 text-sm">
          I tuoi dati personali saranno conservati per il tempo necessario a soddisfare le finalità per cui sono stati
          raccolti, e comunque per non oltre 2 anni.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-3">7. Condivisione dei dati</h2>
        <p class="mb-4 text-sm">
          Non vendiamo né condividiamo i tuoi dati con terze parti, ad eccezione di:
        </p>
        <ul class="list-disc pl-6 mb-4 text-sm">
          <li><strong>Fornitori di servizi</strong>: Ad esempio, Google (per Analytics) e Microsoft (per Clarity)
            potrebbero raccogliere e trattare i tuoi dati in conformità con le loro rispettive politiche sulla privacy.
          </li>
          <li><strong>Obblighi di legge</strong>: Potremmo essere obbligati a condividere i tuoi dati in risposta a
            richieste legali da parte di autorità competenti.</li>
        </ul>

        <h2 class="text-xl font-semibold mt-6 mb-3">8. Diritti dell'utente</h2>
        <p class="mb-4 text-sm">
          In qualità di titolare dei dati, hai il diritto di:
        </p>
        <ul class="list-disc pl-6 mb-4 text-sm">
          <li>Accedere ai tuoi dati personali, correggerli o aggiornarli.</li>
          <li>Richiedere la cancellazione dei tuoi dati, salvo che non vi siano motivi legittimi per la conservazione.
          </li>
          <li>Opporsi al trattamento dei tuoi dati per motivi legittimi.</li>
          <li>Revocare il consenso dato in qualsiasi momento, senza pregiudicare la liceità del trattamento precedente.
          </li>
        </ul>
        <p class="mb-4 text-sm">
          Per esercitare i tuoi diritti, puoi inviarci una richiesta all'indirizzo email: <a
            href="mailto:associazionetau@virgilio.it" class="text-blue-500"> associazionetau@virgilio.it</a>.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-3">9. Sicurezza dei dati</h2>
        <p class="mb-4 text-sm">
          Abbiamo adottato misure di sicurezza tecniche e organizzative per proteggere i tuoi dati personali. Tuttavia,
          ti informiamo che la trasmissione di dati via internet non è mai completamente sicura, quindi non possiamo
          garantire la sicurezza assoluta delle informazioni inviate.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-3">10. Cookie</h2>
        <p class="mb-4 text-sm">
          Il nostro sito utilizza <strong>cookie</strong> per migliorare l'esperienza di navigazione. Puoi scegliere di
          accettare o rifiutare i cookie tramite le impostazioni del tuo browser. I cookie possono essere utilizzati per
          raccogliere informazioni anonime sui tuoi comportamenti di navigazione e per personalizzare i contenuti che ti
          vengono mostrati.
        </p>
        <p class="mb-4 text-sm">
          Per ulteriori informazioni sui cookie utilizzati, consulta la nostra <a href="/cookie-policy"
            class="text-blue-500">Cookie Policy</a>.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-3">11. Modifiche alla Privacy Policy</h2>
        <p class="mb-4 text-sm">
          Ci riserviamo il diritto di aggiornare questa Privacy Policy in qualsiasi momento, in conformità con le
          modifiche alle leggi o alle nostre pratiche aziendali. Ogni aggiornamento sarà pubblicato su questa pagina con
          una data di aggiornamento riportata all'inizio.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-3">12. Contatti</h2>
        <p class="mb-4 text-sm">
          Per qualsiasi domanda riguardo a questa Privacy Policy o sul trattamento dei tuoi dati personali, puoi
          contattarci via email all'indirizzo: <a href="mailto:associazionetau@virgilio.it"
            class="text-blue-500">associazionetau@virgilio.it</a>.
        </p>
      </section>
    </main>

  </div>
</template>

<script lang="ts" setup>

</script>

<style>
</style>